import { render, staticRenderFns } from "./granaryTitle.vue?vue&type=template&id=07aa2738&scoped=true&"
import script from "./granaryTitle.vue?vue&type=script&lang=js&"
export * from "./granaryTitle.vue?vue&type=script&lang=js&"
import style0 from "./granaryTitle.vue?vue&type=style&index=0&id=07aa2738&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aa2738",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07aa2738')) {
      api.createRecord('07aa2738', component.options)
    } else {
      api.reload('07aa2738', component.options)
    }
    module.hot.accept("./granaryTitle.vue?vue&type=template&id=07aa2738&scoped=true&", function () {
      api.rerender('07aa2738', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/granaryTitle.vue"
export default component.exports